<template>
  <div class="website-builder-preview-wrapper">
    <slot />
    <UpsellModal v-model="isUpsellModalOpen" />
  </div>
</template>

<script>
import { isUpsellModalOpen } from '@/features/upsell/modalState'
import UpsellModal from '@/features/upsell/public/UpsellModal.vue'

export default {
  name: 'WebsiteBuilderPreviewWrapper',
  components: { UpsellModal },
  setup() {
    return { isUpsellModalOpen }
  },
}
</script>

<style lang="scss" scoped>
.website-builder-preview-wrapper {
  margin: 0 auto;
  max-width: 900px;
}
</style>
